import { createFileRoute } from "@tanstack/react-router";
import { ProfilePage } from "@/features/profiles";

export const Route = createFileRoute("/_authenticated/account/")({
  component: ProfilePage,
});
